import format from 'date-fns/format';

import { find, get, isNil, isNumber, map, upperCase } from 'lodash';
import { createSelector } from 'reselect';
import { allDoctorsSelector } from '../selectors';
import { pharmaciesSelector } from '../pharmacies';
import { toSuggestion } from './util';
import { PRESCRIPTION_ROUTE } from './constants';

// HELPERS
const toMedication = (medication, pharmacies, doctors) => ({
  activeNumerator: medication.activeNumerator,
  activeNumeratorUnit: medication.activeNumeratorUnit,
  customName: medication.customName,
  alternateName: medication.alternateName,
  datePrescribed: medication.datePrescribed
    ? format(medication.datePrescribed, 'YYYY-MM-DD')
    : null,
  dosage: medication.dosage,
  frequency: medication.frequency,
  frequencyUnit: medication.frequencyUnit,
  id: medication.id,
  notes: medication.notes,
  isSearchResult: !isNil(medication.fdaMedication),
  name:
    get(medication, 'fdaMedication.nonProprietaryName') ||
    medication.customName,
  fdaMedication: toSuggestion(medication.fdaMedication),
  pharmacy: find(pharmacies, { id: medication.pharmacyId }),
  pharmacyId: medication.pharmacyId,
  prescribingDoctor: find(doctors, { id: medication.prescribingDoctorId }),
  prescribingDoctorId: medication.prescribingDoctorId,
  datePresribed: medication.datePresribed,
  prn: medication.prn,
  tempId: medication.tempId,
  type: upperCase(medication.type) === 'IV' ? 'IV' : medication.type,
  recurrenceId: medication.recurrenceId,
  routeId: isNumber(medication.routeId) ? medication.routeId : null,
  route: PRESCRIPTION_ROUTE.toString(medication.routeId),
});

const medicationsSliceSelector = state => get(state, ['dal', 'medications']);

export const medicationsSelector = createSelector(
  [medicationsSliceSelector, pharmaciesSelector, allDoctorsSelector],
  (medications, pharmacies, doctors) =>
    map(medications, medication =>
      toMedication(medication, pharmacies, doctors),
    ),
);



// WEBPACK FOOTER //
// ./src/lib/dataLayer/medications/selectors.js